import { useTranslation } from 'react-i18next'
import DashboardTabLayout from '@/components/dashboard/DashboardTabLayout'

export default function ProfileHub() {
  const { t } = useTranslation('dashboard')

  return (
    <DashboardTabLayout
      title={t('hubs.profile.title')}
      subtitle={t('hubs.profile.subtitle')}
      tabs={[
        {
          id: 'details',
          label: t('hubs.profile.tabs.details'),
          to: '/dashboard/profile/details',
        },
        {
          id: 'gallery',
          label: t('hubs.profile.tabs.gallery'),
          to: '/dashboard/profile/gallery',
        },
        {
          id: 'social',
          label: t('hubs.profile.tabs.social'),
          to: '/dashboard/profile/social',
        },
      ]}
    />
  )
}
